import { httpRequest } from '@lib';
import { useMutation } from '@tanstack/react-query';

const toValueOrNull = (value) => (value || '').trim() || null;

const emptySlots = (count) => Array.from({ length: count }, () => null);

// Capture body mirrors the BE arrays position for position: reasonChips has the
// selected reason's text at its BE index, followUpAnswers the answer at its
// question's BE index; every other slot is null.
const requestPayloadTransformer = ({
  locale, score, selectedReasonSlots, reasons, reasonSlotCount, answers, questions, questionSlotCount, comment,
}) => {
  const reasonChips = emptySlots(reasonSlotCount);
  reasons.forEach(({ text, slot }) => {
    if (selectedReasonSlots.includes(slot)) reasonChips[slot] = text;
  });

  const followUpAnswers = emptySlots(questionSlotCount);
  questions.forEach(({ slot }, index) => {
    followUpAnswers[slot] = toValueOrNull(answers[index]);
  });

  return {
    locale,
    score,
    reasonChips,
    followUpAnswers,
    comment: toValueOrNull(comment),
  };
};

// `captureUrl` is the signed POST URL returned with the feedback form.
const submitFeedback = async ({ captureUrl, ...feedback }) => {
  const { data } = await httpRequest.post(captureUrl, requestPayloadTransformer(feedback), {
    ignoreAuthToken: true,
  });
  return data;
};

export const useSubmitFeedbackMutation = () => useMutation({
  mutationFn: submitFeedback,
});
